<div class="p-l-10 p-r-10 p-t-16 p-b-16">

    <div class="flex flex-middle flex-justify-between">

        <h3 class="h3"
            *iCms="'title' of content; skipEmpty: true"></h3>

        <button class="bg-col-5 b-radius-max flex flex-middle flex-justify-center"
                [style.height.rem]="2.5"
                [style.width.rem]="2.5"
                role="button"
                aria-label="Close"
                (click)="close()">
            <i class="inline-flex icon-close"
               aria-hidden="true"></i>
        </button>
    </div>

    @if (content?.description) {
    <div class="p2 col-12 m-t m-b">
        <cms-text-renderer [text]="content?.description || ''"
                           [data]="placeholderData" />
    </div>
    }

    <div class="w-12 m-t-3 m-b-3"
         [grid]="2"
         [gridColumnGap]="'12px'"
         [gridRowGap]="'12px'">
        @for (packOption of packOptions; track trackByPackId($index, packOption)) {
        <button class="p2 center p-r-2 p-l-2 p-t-6 p-b-6 _option"
                [ngClass]="packOptionId === packOption.id ? 'col-w bg-col-6' : 'col-1 bg-col-5'"
                (click)="selectPackOption(packOption.id)">
            {{packOption.title}}
            <div class="m-t-2 _option-price">
                <price [value]="getMonthlyPriceForPackOption(packOption)"
                       [precision]="2" />&nbsp;<span class="p2">p/m</span>
            </div>
        </button>
        }
    </div>

    @if (info) {
    <ul class="block m-t-3 m-b">
        @for (item of infoItems; track trackByInfoItemTitleValue(index, item); let even = $even; let index = $index) {
        <li class="flex flex-justify-between p-a-2"
            [class.bg-col-5]="even">
            <span class="s2 no-wrap">
                {{item.title}}
            </span>
            @if (!item.isPrice) {
            <span class="p2 right"
                  [ngClass]="{'w-7-s' : index === 0}">
                {{item.value}}
            </span>
            }
            @if (item.isPrice) {
            <price class="p2 right"
                   [value]="asNumber(item.value)"
                   [precision]="2"></price>
            }
        </li>
        }
    </ul>
    <p class="p2 col-12 m-t m-b"
       *iCms="'footer' of content; skipEmpty: true"></p>
    }
</div>